module.exports = __webpack_public_path__ + "media/images/logo-green-954fa4209d3d3d0336fc72f9f301e0fa.svg";